module.exports = __webpack_public_path__ + "468e08c2c25d9adfdb3a0f88392f3a9a.svg";